module.exports = __webpack_public_path__ + "img/@team_img_01_.50eb6447.jpg";